module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetLow@2x.bbc4dab.webp";